// extracted by mini-css-extract-plugin
export default {"aboutWrapper":"css_aboutWrapper__ff-Lq","dev_page_content":"css_dev_page_content__5CbAj"};